import React from 'react';
export function CampaignArchiveIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M9.5 12a1.5 1.5 0 000 3h5a1.5 1.5 0 000-3h-5z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2h22v8h-2v12H3V10H1V2zm4 18h14V10H5v10zM19 8h2V4H3v4h2a2 2 0 012-2h10a2 2 0 012 2z"
  }));
}